import { IToaster, Toaster } from "@blueprintjs/core";
import { createContext } from "react";

type ToasterContext = {
    toaster: IToaster | undefined
}

export const ToasterContext = createContext<ToasterContext>({
    toaster: undefined,
})